import React from "react";

function ComponentDetails({ object }) {
  return (
    <div className="border rounded  p-2 max-w-3xl mx-auto">
      <h6 className="text-lg font-semibold text-gray-700 mb-4">
        Details - Component
      </h6>
      <hr />
      <div className="">
        <p className="m-0">
          <strong className="font-medium">Item Name :</strong>{" "}
          {object?.component?.itemName}
        </p>
        <p className="m-0">
          <strong className="font-medium">Quantity :</strong> {object?.quantity}
        </p>
        <p className="m-0">
          <strong className="font-medium">Unit of Measurement :</strong>{" "}
          {object?.component?.uom?.name}
        </p>
        <p className="m-0">
          <strong className="font-medium">Date Created :</strong>{" "}
          {new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          }).format(new Date(object?.created))}
        </p>
      </div>
    </div>
  );
}

export default ComponentDetails;
